import config from "../config"
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Stack,
  Unstable_Grid2 as Grid2,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@mui/material";

const PostFormUtils = () => {
  const [formData, setFormData] = useState({
    uuid: "",
    customer_name: ""
  });

  // Change taskData to be an array of objects (not separate uuid and status arrays)
  const [taskData, setTaskData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const username = sessionStorage.getItem("username");
      try {
        const response = await fetch(`${config.apiUrl}/get_all_tasks/${username}`);
        if (response.ok) {
          const tasks = await response.json();
          console.log('Success:', tasks);
          
          // Convert each task item to the required format (an array of objects)
          const formattedData = tasks.map(t => ({
            uuid: t.uuid,
            task_status_string: t.status_string["overall"] // Assuming status_string is an object
          }));

          // Update state with the formatted data
          setTaskData(formattedData);

        } else {
          console.error('Error:', response.statusText);
          alert(`Error: ${response.statusText}`);
        }
      } catch (error) {
        console.error('Network Error:', error);
        alert('Network Error: Failed to submit the form.');
      };
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs once when the component mounts

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Update the specific field
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = [
      {
        ...formData
      },
    ];
    
    try {
        const response = await fetch(`${config.apiUrl}/retry_task`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (response.ok) {
          const data = await response.json();
          console.log('Success:', data);
          alert('Form submitted successfully!');
        } else {
          console.error('Error:', response.statusText);
          alert(`Error: ${response.statusText}`);
        }
      } catch (error) {
        console.error('Network Error:', error);
        alert('Network Error: Failed to submit the form.');
    };

    console.log("Form Submitted:", formData);
    // Reset the form after submission
    setFormData({
      uuid: "",
      customer_name: ""
    });
  };

  return (
    <Container maxWidth="xl">
      <Grid2 container spacing={4}>
        <Grid2 item xs={12} md={12}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              mt: 4,
              p: 3,
              width: "100%",
              borderRadius: 2,
              boxShadow: 3,
              bgcolor: "white",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Retry Task
            </Typography>

            <Stack spacing={3}>
              <TextField
                label="Task ID"
                name="uuid"
                value={formData.uuid}
                onChange={handleChange}
                fullWidth
                required
              />

              <TextField
                label="Customer Name"
                name="customer_name"
                value={formData.customer_name}
                onChange={handleChange}
                fullWidth
                required
              />

              <Button type="submit" variant="contained" color="primary" fullWidth>
                Submit
              </Button>
            </Stack>
          </Box>
        </Grid2>

        {/* Right side: Task List */}
        <Grid2 item xs={12} md={12}>
          <Box
            sx={{
              ml: 4,
              mt: 4,
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              bgcolor: "white",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Task List
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Task ID</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {taskData.map((task) => (
                    <TableRow key={task.uuid}>
                      <TableCell>{task.uuid}</TableCell>
                      <TableCell>{task.task_status_string}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid2>
      </Grid2>
    </Container>
  );
};

export default PostFormUtils;
